import { mapActiveInactiveStatusEnumToItemLabelModel } from '../../../../shared/utils/mapping/mapping.util';
import { mapPlatformModelToItemLabelModel } from '../../../shared/utils/mapping/mapping.utils';
import { FirmwareDetailsFormModel } from '../../components/FirmwareDetailsForm/models/firmware-form.model';
import { FirmwareResponseModel } from '../../models/firmware-response.model';
import {
  mapAttendedECUToItemLabelModel,
  mapBrandModelToItemLabelModel,
  mapModelEntityToItemLabelModel,
} from '../mapping/mapping.util';

export const firmwareModelToFormik = (
  data: FirmwareResponseModel
): FirmwareDetailsFormModel => ({
  model: mapModelEntityToItemLabelModel(data.model),
  name: data.name,
  brand: mapBrandModelToItemLabelModel(data.brand),
  ecu: mapAttendedECUToItemLabelModel(data.ecu),
  platform: mapPlatformModelToItemLabelModel(data.platform),
  versionName: data.versionName,
  versionCode: data.versionCode,
  description: data.description,
  status: mapActiveInactiveStatusEnumToItemLabelModel(data.status),
  firmwareFileId: data.file.id,
});
